import {FC, ReactNode, useRef, useState} from 'react'
import {useOnClickOutside} from 'usehooks-ts'
import SVGIcon from './SVGIcon'

type ILimitOption = {
    value: number
    label: string
}

type ILimitSelectDropdownProps = {
    options: Array<ILimitOption>
    selected: number
    toggleOption: ICallbackFunction
}

type ICallbackFunction = (value: number) => void

const LimitSelectDropdown: FC<ILimitSelectDropdownProps> = ({options, selected, toggleOption}): ReactNode => {
    const [isOpen, setIsOpen] = useState(false)

    const ref = useRef(null)

    const currentlySelectedOption = options.find((element: ILimitOption) => element.value === selected)

    const handleOpen = () => {
        setIsOpen(!isOpen)
    }

    const handleSelect = (value: number) => {
        toggleOption(value)
        setIsOpen(false)
    }

    useOnClickOutside(ref, () => {
        setIsOpen(false)
    })

    return (
        <div ref={ref} className={'c-limit-select-dropdown' + (isOpen ? ' c-limit-select-dropdown__active' : '')}>
            <div className="c-limit-select-dropdown__selected" onClick={handleOpen}>
                <div className="c-limit-select-dropdown__page flex">
                    {currentlySelectedOption?.label}
                    <span className="check" style={{width: '16px'}}>
                        <SVGIcon
                            id={'check-icon-blue'}
                            className={'light-blue'}
                            width={16}
                            height={24}
                            fill={'#006192'}
                        />
                    </span>
                </div>
            </div>

            <ul className="c-limit-select-dropdown__options">
                {options.map((option: ILimitOption, index: number) => {
                    return (
                        <li
                            key={'limit_option_idx_' + index.toString()}
                            className="c-limit-select-dropdown__option"
                            onClick={() => handleSelect(option.value)}>
                            <label className="flex" htmlFor={'limit_option_item_' + index.toString()}>
                                <input
                                    id={'limit_option_item_' + index.toString()}
                                    type="checkbox"
                                    checked={option.value === selected}
                                    className="c-limit-select-dropdown__option-checkbox"
                                    readOnly
                                />
                                <span className="check-mark"></span>
                                <span className="check-label">{option.label}</span>
                            </label>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default LimitSelectDropdown
